const vehicleMap = {
  active: 'vehicleActive',
  publish: 'vehiclePublish',
  type: 'vehicleType',
  fuel: 'vehicleFuel',
  brand: 'vehicleBrand',
  name: 'vehicleName',
  version: 'vehicleVersion',
  year_start: 'vehicleYearStart',
  year_end: 'vehicleYearEnd',
  molicar_code: 'vehicleMolicarCode',
  fipe_code: 'vehicleFipeCode',
  price_cents: 'vehiclePriceCents',
  picture: 'vehiclePicture',
};

export default vehicleMap;
